import { FC } from "react"
import { devicesTypes } from "../devices-modal"


export type DevicesTypeItemProps = { 
    data: devicesTypes
    selectOption: (value: "audio" | "video") => void
}

const DevicesTypeItem: FC<DevicesTypeItemProps> = (props) => {

    return(
        <div className='SideBarMenu__Item' onClick={() => props.selectOption(props.data.type)}>
            <i className={props.data.icon} />
            <p className="SideBarMenu__Body1">{props.data.label}</p>
        </div>
    )
}

export default DevicesTypeItem
